/* tslint:disable:max-line-length */
import { DefaultMessages, RequestOrganizationMessages } from '@sheerid/jslib';

type RecursivePartial<T> = {
    [P in keyof T]?: RecursivePartial<T[P]>;
};

type ThisProjectMessages = {
    locales: {
        en: string, // need to support `en` in additon to `en-US` for ADSK's requirements
        is: string, // need to support `is` for ADSK's requirements
        ro: string, // need to support `ro` for ADSK's requirements
    },
    countries: {
        CD: string, // the jslib doesn't include a country code for Democratic Republic of Congo
        CZ: string, // the jslib uses the incorrect country code for Czech Republic
        PS: string, // the jslib doesn't include a country code for Palestine
        SS: string, // the jslib doesn't include a country code for South Sudan
        TL: string, // the jslib doesn't include a country code for Timor-Leste
    },
};


type LibraryMessages = DefaultMessages & RequestOrganizationMessages;

export const daRequestOrgMessages: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    title: 'Anmod om at tilføje skole',
    description: 'Udfyld venligst formularen nedenfor. Indsendte skoler er ikke garanteret tilføjelse, men alle anmodninger bliver undersøgt og overvejet af SheerID. ',
    noCountry: 'Ser du ikke din skoles land? Du er ikke kvalificeret til dette tilbud',
    searchByOrgName: 'Ser du ikke din skole? Søg efter navn',
    completeRequest: 'Ser du ikke din skole på listen over kvalificerede eller ukvalificerede skoler? Gennemfør din anmodning',
    submit: 'Indsend',
    eligibleOrgs: 'Kvalificerede skoler. Klik på ikonet for at kopiere navnet og vend tilbage til verificeringsformularen',
    ineligibleOrgs: 'Ukvalificerede skoler. Beklager, studerende på disse skoler er ikke kvalificeret til dette tilbud',
    none: 'Ingen',
    country: 'Hvor går du i skole?',
    changeLanguage: 'Skift sprog',
    copied: 'Kopieret',
    firstName: 'Fornavn',
    lastName: 'Efternavn',
    emailAddress: 'Email adresse',
    poweredBy: 'Verificeringsservice drevet af SheerID',
    fields: {
        countryPlaceholder: 'Vælg land',
        domainLabel: 'Skolens hjemmeside',
        domainPlaceholder: 'www.minskole.edu',
        orgNameLabel: 'Skolens navn',
        orgNamePlaceholder: 'Min skole',
    },
    step: {
        success: {
            title: 'Tak fordi du indsendte din anmodning',
            description: 'Husk, at hver anmodning vurderes af SheerID i henhold til kravene for dette tilbud. Der er ikke nogen garanti for, at din skole bliver tilføjet. Vurderingsprocessen tager op til syv dage.',
        },
        error: {
            title: 'Der opstod en uventet fejl',
            description: 'Beklager vi er ikke i stand til at gennemføre din anmodning. Prøv venligst igen senere.',
            seeingProblem: 'Hvis du bliver ved med at opleve denne fejl',
            contactUs: 'kontakt os',
        },
    },
    errorId: {
        invalidCountry: 'Felt er påkrævet',
        invalidEmail: 'Ugyldig e-mail',
        invalidFirstName: 'Ugyldigt fornavn',
        invalidLastName: 'Ugyldigt efternavn',
        requiredField: 'Felt er påkrævet',
        invalidField: 'Ugyldigt felt',
        invalidUrl: 'Ugyldig URL',
        tooManyResults: 'Din søgning gav for mange resultater, indsnævr venligst din søgning og prøv igen',
    },
    faq: 'SheerID Anmodning Om At Tilføje Skole FAQ',
    countries: {
        AD: ' Andorra',
        AE: 'De Forenede Arabiske Emirater',
        AF: 'Afghanistan',
        AG: 'Antigua og Barbuda',
        AI: 'Anguilla',
        AL: 'Albanien',
        AM: 'Armenien',
        AN: 'De Nederlandske Antiller',
        AO: 'Angola',
        AR: 'Argentina',
        AS: 'Amerikansk Samoa',
        AT: 'Østrig',
        AU: 'Australien',
        AW: 'Aruba',
        AZ: 'Aserbajdsjan',
        BA: 'Bosnien-Hercegovina',
        BB: 'Barbados',
        BD: 'Bangladesh',
        BE: 'Belgien',
        BF: 'Burkina Faso',
        BG: 'Bulgarien',
        BH: 'Bahrain',
        BI: 'Burundi',
        BJ: 'Benin',
        BM: 'Bermuda',
        BN: 'Brunei Darussalam',
        BO: 'Bolivia',
        BR: 'Brasilien',
        BS: 'Bahamas',
        BT: 'Bhutan',
        BV: 'Bouvetøen',
        BW: 'Botswana',
        BY: 'Hviderusland',
        BZ: 'Belize',
        CA: 'Canada',
        CD: 'Den Demokratiske Republik Congo',
        CF: 'Den Centralafrikanske Republik',
        CG: 'Congo',
        CH: 'Schweiz',
        CI: 'Elfenbenskysten (Cote D\'Ivoire)',
        CK: 'Cookøerne',
        CL: 'Chile',
        CM: 'Cameroun',
        CN: 'Kina',
        CO: 'Colombia',
        CR: 'Costa Rica',
        CU: 'Cuba',
        CV: 'Kap Verde',
        CY: 'Cypern',
        CZ: 'Tjekkiet',
        DE: 'Tyskland',
        DJ: 'Djibouti',
        DK: 'Danmark',
        DM: 'Dominica',
        DO: 'Den Dominikanske Republik',
        DZ: 'Algeriet',
        EC: 'Ecuador',
        EE: 'Estland',
        EG: 'Egypten',
        EH: 'Vestsahara',
        ER: 'Eritrea',
        ES: 'Spanien',
        ET: 'Etiopien',
        FI: 'Finland',
        FJ: 'Fiji',
        FK: 'Falklandsøerne',
        FM: 'Mikronesien',
        FO: 'Færøerne',
        FR: 'Frankrig',
        GA: 'Gabon',
        GB: 'Det Forenede Kongerige',
        GD: 'Grenada',
        GE: 'Georgien',
        GF: 'Fransk Guyana',
        GH: 'Ghana',
        GI: 'Gibraltar',
        GL: 'Grønland',
        GM: 'Gambia',
        GN: 'Guinea',
        GP: 'Guadeloupe (fransk)',
        GQ: 'Ækvatorial Guinea',
        GR: 'Grækenland',
        GS: 'South Georgia og De Sydlige Sandwichøer',
        GT: 'Guatemala',
        GU: 'Guam (USA)',
        GW: 'Guinea-Bissau',
        GY: 'Guyana',
        HK: 'Hong Kong',
        HM: 'Heard og McDonald Islands',
        HN: 'Honduras',
        HR: 'Kroatien',
        HT: 'Haiti',
        HU: 'Ungarn',
        ID: 'Indonesien',
        IE: 'Irland',
        IL: 'Israel',
        IN: 'Indien',
        IO: 'Det Britiske Territorium i Det Indiske Ocean',
        IQ: 'Irak',
        IR: 'Iran',
        IS: 'Island',
        IT: 'Italien',
        JM: 'Jamaica',
        JO: 'Jordan',
        JP: 'Japan',
        KE: 'Kenya',
        KG: 'Kirgisistan',
        KH: 'Cambodja',
        KI: 'Kiribati',
        KM: 'Comorerne',
        KN: 'Saint Kitts & Nevis Anguilla',
        KP: 'Nordkorea',
        KR: 'Sydkorea',
        KW: 'Kuwait',
        KY: 'Caymanøerne',
        KZ: 'Kasakhstan',
        LA: 'Laos',
        LB: 'Libanon',
        LC: 'Saint Lucia',
        LI: 'Liechtenstein',
        LK: 'Sri Lanka',
        LR: 'Liberia',
        LS: 'Lesotho',
        LT: 'Litauen',
        LU: 'Luxembourg',
        LV: 'Letland',
        LY: 'Libyen',
        MA: 'Marokko',
        MC: 'Monaco',
        MD: 'Moldavien',
        ME: 'Montenegro',
        MG: 'Madagaskar',
        MH: 'Marshalløerne',
        MK: 'Makedonien',
        ML: 'Mali',
        MM: 'Myanmar',
        MN: 'Mongoliet',
        MO: 'Macau',
        MP: 'Nordmarianerne',
        MQ: 'Martinique (fransk)',
        MR: 'Mauretanien',
        MS: 'Montserrat',
        MT: 'Malta',
        MU: 'Mauritius',
        MV: 'Maldiverne',
        MW: 'Malawi',
        MX: 'Mexico',
        MY: 'Malaysia',
        MZ: 'Mozambique',
        NA: 'Namibia',
        NC: 'Ny Kaledonien (fransk)',
        NE: 'Niger',
        NF: 'Norfolk Island',
        NG: 'Nigeria',
        NI: 'Nicaragua',
        NL: 'Holland',
        NO: 'Norge',
        NP: 'Nepal',
        NR: 'Nauru',
        NU: 'Niue',
        NZ: 'New Zealand',
        OM: 'Oman',
        PA: 'Panama',
        PE: 'Peru',
        PF: 'Polynesien (fransk)',
        PG: 'Papua Ny Guinea',
        PH: 'Filippinerne',
        PK: 'Pakistan',
        PL: 'Polen',
        PM: 'Saint Pierre og Miquelon',
        PN: 'Pitcairn Island',
        PR: 'Puerto Rico',
        PS: 'Palæstina',
        PT: 'Portugal',
        PW: 'Palau',
        PY: 'Paraguay',
        QA: 'Qatar',
        RE: 'Reunion (fransk)',
        RO: 'Rumænien',
        RS: 'Serbien',
        RU: 'Den Russiske Føderation',
        RW: 'Rwanda',
        SA: 'Saudi-Arabien',
        SB: 'Salomonøerne',
        SC: 'Seychellerne',
        SD: 'Sudan',
        SE: 'Sverige',
        SG: 'Singapore',
        SH: 'Sankt Helena',
        SI: 'Slovenien',
        SK: 'Slovakiske Republik',
        SL: 'Sierra Leone',
        SM: 'San Marino',
        SN: 'Senegal',
        SO: 'Somalia',
        SR: 'Surinam',
        SS: 'Sydsudan',
        ST: 'Saint Tome (Sao Tome) og Principe',
        SV: 'El Salvador',
        SY: 'Syrien',
        SZ: 'Swaziland',
        TC: 'Turks- og Caicosøerne',
        TD: 'Tchad',
        TF: 'Franske Besiddelser i Det Sydlige Indiske Ocean',
        TG: 'Togo',
        TH: 'Thailand',
        TJ: 'Tadsjikistan',
        TK: 'Tokelau',
        TL: 'Østtimor',
        TM: 'Turkmenistan',
        TN: 'Tunesien',
        TO: 'Tonga',
        TR: 'Tyrkiet',
        TT: 'Trinidad og Tobago',
        TV: 'Tuvalu',
        TW: 'Taiwan',
        TZ: 'Tanzania',
        UA: 'Ukraine',
        UG: 'Uganda',
        UM: 'USA Mindre Afsidesliggende Øer',
        US: 'De Forenede Stater',
        UY: 'Uruguay',
        UZ: 'Usbekistan',
        VA: 'Vatikanstaten',
        VC: 'Saint Vincent og Grenadinerne',
        VE: 'Venezuela',
        VG: 'Jomfruøerne (britiske)',
        VI: 'Jomfruøerne (USA)',
        VN: 'Vietnam',
        VU: 'Vanuatu',
        WF: 'Wallis- og Futuna-øerne',
        WS: 'Samoa',
        XK: 'Kosovo',
        YE: 'Yemen',
        YT: 'Mayotte',
        ZA: 'Sydafrika',
        ZM: 'Zambia',
        ZW: 'Zimbabwe',
    },
    locales: {
        ar: ' Arabisk',
        bg: 'Bulgarsk',
        cs: 'Tjekkisk',
        da: 'Dansk',
        de: 'Tysk',
        el: 'Græsk',
        'en-GB': 'Engelsk (UK)',
        'en-US': 'Engelsk',
        'es-ES': 'Spansk (Spanien)',
        es: 'Spansk',
        fi: 'Finsk',
        'fr-CA': 'Fransk (canadisk)',
        fr: 'Fransk',
        hr: 'Kroatisk',
        hu: 'Ungarsk',
        id: 'Indonesisk',
        is: 'Islandsk',
        it: 'Italiensk',
        iw: 'Hebraisk',
        ja: 'Japansk',
        ko: 'Koreansk',
        lt: 'Litauisk',
        ms: 'Malaysisk',
        nl: 'Hollandsk',
        no: 'Norsk',
        pl: 'Polsk',
        'pt-BR': 'Portugisisk (Brasilien)',
        pt: 'Portugisisk',
        ro: 'Rumænsk',
        ru: 'Rusland',
        sk: 'Slovakisk',
        sl: 'Slovensk',
        sr: 'Serbisk',
        sv: 'Svensk',
        tr: 'Tyrkisk',
        'zh-HK': 'Kinesisk (Hong Kong)',
        zh: 'Kinesisk (traditionel)',
    },
};
